import { ChannelListScreenNavigationProps } from "./types"
import React from "react"
import ChannelList from "./channel-list-screen"
import { PageRoot } from "~screens/page-root"


const ChannelListScreen: React.FC<ChannelListScreenNavigationProps> = () => {
  return (
    <PageRoot>
      <ChannelList />
    </PageRoot>
  )
}

export default ChannelListScreen
